export { default as PatientBackgroundSection } from './PatientBackgroundSection'
export { PatientBackgroundAdapter } from './adapter'
export type { PatientBackgroundFormData } from './formData'
export { PatientBackgroundFormField } from './formField'
export { PatientBackgroundQuestionnaireItem } from './questionnaire'
export { PATIENT_BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './questionnaireAnswer'
